import { useEffect, useState } from 'react'
import useMineralsActions from './useMineralsActions'
import { useParams } from 'react-router-dom/dist/umd/react-router-dom.development'

export default function useMineralCountryDetails() {
  const { mineral_id, country_id } = useParams()
  const [details, setDetails] = useState(null)
  const [isLoading, setIsLoading] = useState(null)

  const { getMineralCountryDetails } = useMineralsActions()

  async function fetchMineralDetailsForCountry(mineralId, countryId) {
    try {
      setIsLoading(true)
      const details = await getMineralCountryDetails(mineralId, countryId)
      setDetails(details)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchMineralDetailsForCountry(mineral_id, country_id)
  }, [mineral_id, country_id])

  return { isLoading, details }
}
